import { Button, ButtonProps, Theme, styled } from "@mui/material";

import React from "react";

interface StyledBookAVisitButtonProps extends ButtonProps {
  isOpenSidebar: boolean;
}

export const BoxContent = styled("div")({
  display: "flex",
  height: "100vh",
  maxWidth: "100vw",
  overflow: "auto",
  overflowX: "hidden",
});

export const sidebarStyle = (theme: Theme) => ({
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
});

export const mainContentStyle = (theme: Theme) => ({
  flexGrow: 1,
  width: "100%",
  minWidth: 0,
});

export const panelRightStyle = (theme: Theme) => ({
  minWidth: "30rem !important",
  maxWidth: "30rem !important",
  position: "sticky",
  top: 0,
  [theme.breakpoints.down(1100)]: {
    display: "none",
  },
});

export const bookAVisitMobile = () => ({
  position: "fixed",
  bottom: "2rem",
  right: "1.5rem",
  borderRadius: "50%",
  padding: "0.75rem",
  height: "3.625rem",
  width: "3.625rem",
  boxShadow: "0px 0.625rem 0.625rem rgba(0, 0, 0, 0.1)",
  zIndex: 3,
}
);

export const locationButtonStyle = () => ({
  margin: "2.5rem 0.5rem 0",
  borderRadius: "0.25rem",
  padding: "0.75rem",
  height: "3rem",
  background: "#F4EFEB",
});

export const StyledBookAVisitButton = styled(({ isOpenSidebar, ...props }: StyledBookAVisitButtonProps) => (
  <Button {...props} />
))(({ isOpenSidebar }) => ({
  fontSize: "0.8rem",
  margin: isOpenSidebar ? "2rem 1.5rem" : "0 0 0.5rem 0",
  padding: isOpenSidebar ? "1.3rem" : "0.75rem",
  textTransform: "none",
  ...(isOpenSidebar ? {} : { borderRadius: "0.25rem", height: "3rem" }),
}));
